import { Alert, Col, Form, Row } from "antd";
import QuoteDisplay from "../components/QuoteDisplay";
import QuoteForm from "../components/QuoteForm";
import { useState } from "react";
import { base_city_discount, base_type_discount, city_tier_relationship, ghi_quotes, ghi_quotes_under_25, gpa_quotes, gtli_quotes, hnw_quotes, opd_quotes, without_maternity, without_maternity_under_25 } from "../db/quotes";
import Logout from "../components/Logout";

interface Props {
  logout: () => void;
}

interface Quote {
  id: number;
  ghi_si: string;
  e: number;
  esc: number;
  escp: number;
}

interface AddOn {
  gpa?: number | null;
  gtli?: number | null;
  dental_cover?: number | null;
  doctor_teleconsultations?: number | null;
  gym_membership?: number | null;
  health_checkups?: number | null;
  emotional_wellness?: number | null;
}

const FreshPage: React.FC<Props> = ({ logout }) => {
  const [form] = Form.useForm(),
    [data, setData] = useState<null | Array<Quote>>(null),
    [ghiData, setGhiData] = useState<null | Array<Quote>>([]),
    [alertMessage, setAlertMessage] = useState<string | null>(null),
    [addOn, setAddOn] = useState<AddOn | null>(null),
    onFormSubmit = () => {
      form.validateFields()
        .then((values) => {
          let opdPremium = 0;
          let addon = 0;
          let discount = 0;
          let addOnDetails = {} as any;
          if (values?.gym_membership) {
            addon += hnw_quotes?.gym_membership?.find((item) => item.plan === values?.gym_membership)?.premium || 0;
            addOnDetails.gym_membership = hnw_quotes?.gym_membership?.find((item) => item.plan === values?.gym_membership)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.health_checkups) {
            addon += hnw_quotes?.health_checkups?.find((item) => item.plan === values?.health_checkups)?.premium || 0;
            addOnDetails.health_checkups = hnw_quotes?.health_checkups?.find((item) => item.plan === values?.health_checkups)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.emotional_wellness) {
            addon += hnw_quotes?.emotional_wellness?.find((item) => item.plan === values?.emotional_wellness)?.premium || 0;
            addOnDetails.emotional_wellness = hnw_quotes?.emotional_wellness?.find((item) => item.plan === values?.emotional_wellness)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.dental_cover) {
            addon += hnw_quotes?.dental_cover?.find((item) => item.plan === values?.dental_cover)?.premium || 0;
            addOnDetails.dental_cover = hnw_quotes?.dental_cover?.find((item) => item.plan === values?.dental_cover)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.doctor_teleconsultations) {
            addon += hnw_quotes?.doctor_teleconsultation?.find((item) => item.plan === values?.doctor_teleconsultations)?.premium || 0;
            addOnDetails.doctor_teleconsultations = hnw_quotes?.doctor_teleconsultation?.find((item) => item.plan === values?.doctor_teleconsultations)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.gpa) {
            addon += gpa_quotes?.find((item) => item.gpa_si === values?.gpa)?.premium || 0;
            addOnDetails.gpa = gpa_quotes?.find((item) => item.gpa_si === values?.gpa)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.gtli) {
            addon += gtli_quotes?.find((item) => item.gtli_si === values?.gtli)?.premium || 0;
            addOnDetails.gtli = gtli_quotes?.find((item) => item.gtli_si === values?.gtli)?.premium.toLocaleString('en-IN') || 0;
          }
          if (values?.plan_type) {
            discount += base_type_discount?.find((item) => item.plan_type === values?.plan_type)?.discount || 0;
          }
          if (values?.city) {
            if (values?.employee_count > 25) discount += base_city_discount?.find((item) => item?.tier === city_tier_relationship?.find((item) => item?.cities?.includes(values?.city))?.tier)?.discount || 0;
          }
          if (values?.opd) {
            opdPremium = opd_quotes?.find((item) => item.opd_si === values?.opd)?.premium || 0;
          }
          let ghi_dataSource = [] as any;
          if (values?.employee_count > 25) {
            ghi_dataSource = ghi_quotes?.map((item) => {
              let row = item;
              if (!values?.maternity_cover) {
                row = {
                  ...row,
                  e: row.e + without_maternity['e'],
                  esc: row.esc + without_maternity['esc'],
                  escp: !row.escp ? 0 : (row.escp + without_maternity['escp']),
                }
              }
              return {
                ...row,
                e: Math.ceil((1 - discount) * (row.e)),
                esc: Math.ceil((1 - discount) * (row.esc)),
                escp: !row.escp ? null : Math.ceil((1 - discount) * (row.escp)),
              }
            })
          } else {
            ghi_dataSource = ghi_quotes_under_25?.map((item) => {
              let row = item;
              if (!values?.maternity_cover) {
                row = {
                  ...row,
                  e: row.e + (without_maternity_under_25?.find((item) => item.ghi_si === row.ghi_si)?.e ?? 0),
                  esc: row.esc + (without_maternity_under_25?.find((item) => item.ghi_si === row.ghi_si)?.esc ?? 0),
                  escp: row.escp + (without_maternity_under_25?.find((item) => item.ghi_si === row.ghi_si)?.escp ?? 0),
                }
              }
              return {
                ...row,
                e: item?.ghi_si === "10L" ? null : Math.ceil((1 - discount) * (row.e)),
                esc: item?.ghi_si === "10L" ? null : Math.ceil((1 - discount) * (row.esc)),
                escp: null,
              }
            })
          }
          let minEmployeeCountForE = values?.maternity_cover ? 10 : 7;
          let minEmployeeCountForESC = values?.maternity_cover? 10 : 5;

          let employeeCount7OrMore = Math.max(minEmployeeCountForE, values?.employee_count);
          let employeeCount5OrMore = Math.max(minEmployeeCountForESC, values?.employee_count);

          if (values?.employee_count < 7 && !values?.maternity_cover) {
            setAlertMessage("The charges below are given for minimum 7 lives (for cases where employees <7)")
          }

          if (values?.employee_count < 10 && values?.maternity_cover) {
            setAlertMessage("The charges below are given for minimum 10 employees (for cases where employees <10)")
          }

          setData(ghi_dataSource?.map((item: any) => {
            return {
              ...item,
              e: item.e ? (item.e + addon + opdPremium) * employeeCount7OrMore : null,
              esc: item.esc ? (item.esc + addon + opdPremium) * employeeCount5OrMore : null,
              escp: item.escp ? (item.escp + addon + opdPremium) * employeeCount5OrMore : null
            }
          }))
          setAddOn({ ...addOnDetails, ...values?.opd && { opd: opdPremium.toLocaleString('en-IN') } })
          setGhiData(ghi_dataSource)
        })
        .catch((err) => {
          // console.error(err);
        });
    },
    onFormReset = () => {
      form.resetFields();
      setData(null);
    };

  return <div className="layout">
    <div className="container">
      <Logout logout={logout} />
      <Row justify={"center"} style={{ padding: "24px 0 24px 0" }}>
        <h1>Generate Fresh Quote in under a minute!</h1>
      </Row>
      <Row gutter={64} align="top">
        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <QuoteForm form={form} onFormSubmit={onFormSubmit} onFormReset={onFormReset} />
        </Col>
        {data && ghiData && <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} style={{ marginBottom: "24px" }}>
          <QuoteDisplay quote={data} ghi_quote={ghiData} addOn={addOn} alertMessage={alertMessage} />
        </Col>}
        {!data && <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <Alert type="info" message="Quote will be shown here" style={{ textAlign: "center", padding: "64px 0", marginBottom: "24px" }} />
        </Col>}
      </Row>
    </div>
  </div>
};

export default FreshPage;
